import useBreakpoint from "@/hooks/useBreakpoint";
import React from "react";
import TopBar from "@/components/TopBar";
import Column from "@/components/Column";
import Text from "@/components/Text";
import Columns from "@/components/Columns";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

export default function PageLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isOnBreakpoint: isTableOrLess } = useBreakpoint(1246);
  return (
    <div className="min-h-screen bg-[#f4f6f9]">
      <SEO
        title="Escolha o seu plano TIM"
        description="Adicione o plano TIM que deseja para começar o processo de compra."
      />
      {!isTableOrLess && <TopBar />}

      <Columns
        className="mx-auto flex max-w-2xl flex-col items-center justify-center px-4 pb-4 pt-8 lg:px-6"
        useNegativeMargin={false}
      >
        <Column size={12} className="text-center">
          {isTableOrLess && (
            <>
              <img
                className="mb-8 inline-block"
                src="/tim_logo.svg"
                alt="Logo da TIM"
              />
              <Text kind="blue" size="2xl">
                Planos de internet exclusivos, ideais para você!
              </Text>
            </>
          )}
        </Column>
        <Column size={12}>{children}</Column>
        <Column size={12}>
          <Column className="mt-8">
            <Footer showText />
          </Column>
        </Column>
      </Columns>
    </div>
  );
}
